export default __webpack_public_path__ + "static/illustration-content-logo.url-28f86b514cec23397bc4c2aada2fe3a1.svg";